import IconButton from '@material-ui/core/IconButton';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import { PermissionsProvider } from 'providers/permissionsProvider';
import { CAN_EDIT_SUB_DIVISION } from 'providers/permissions';

type PricingIconButtonProps = {
  record: any;
  onClick: (subdivisionId: string) => void;
};

export const PricingIconButton = ({
  record,
  onClick,
}: PricingIconButtonProps) => {
  const { hasPermission } = PermissionsProvider.useContainer();

  if (!hasPermission(CAN_EDIT_SUB_DIVISION)) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick(record.id);
  };

  return (
    <IconButton
      onClick={handleClick}
      size="small"
      data-cy="subdivisionPricingButton"
      title="Edit Cost Structure"
    >
      <AttachMoneyIcon />
    </IconButton>
  );
};
